import { TargetType } from "../enums/TargetType.js";
const FEATURES_BY_CATEGORY = {
    "Soins animaliers": {
        hasPatients: true,
        allowedTargetTypes: [TargetType.HORSE, TargetType.DOG, TargetType.CAT],
    },
    "Soin humain": {
        hasPatients: true,
        allowedTargetTypes: [TargetType.HUMAN],
    },
    Entretien: { hasPatients: false },
    Dépannage: { hasPatients: false },
    Autre: { hasPatients: false },
};
export const TARGET_TYPE_LABELS = {
    [TargetType.HORSE]: "Cheval",
    [TargetType.DOG]: "Chien",
    [TargetType.CAT]: "Chat",
    [TargetType.HUMAN]: "Humain",
};
const DEFAULT_FEATURES = { hasPatients: false };
export function isEquineJob(jobTitle) {
    return ["Maréchal-ferrant", "Podologue équin", "Technicien dentaire équin"].includes(jobTitle ?? "");
}
export function getServiceTargetLabels(isEquine = false) {
    return isEquine
        ? {
            singular: "Cheval",
            plural: "Chevaux",
            create: "Nouveau cheval",
            add: "Ajouter un cheval",
            addError: "Erreur lors de l'ajout du cheval",
            updateError: "Erreur lors de la mise à jour du cheval",
        }
        : {
            singular: "Patient",
            plural: "Patients",
            create: "Nouveau patient",
            add: "Ajouter un patient",
            addError: "Erreur lors de l'ajout du patient",
            updateError: "Erreur lors de la mise à jour du patient",
        };
}
export function getJobCategoryFeatures(jobCategory, jobTitle) {
    if (isEquineJob(jobTitle)) {
        return { hasPatients: true, allowedTargetTypes: [TargetType.HORSE] };
    }
    if (!jobCategory) {
        return DEFAULT_FEATURES;
    }
    return FEATURES_BY_CATEGORY[jobCategory] ?? DEFAULT_FEATURES;
}
export function isRamonage(company) {
    return company?.features.jobTitle === "Ramoneur";
}
export function isJardinier(company) {
    return company?.features.jobTitle === "Jardinier à domicile";
}
const DEFAULT_JOB_TITLE_DEFAULTS = {
    duplicationWeeks: [4, 6, 8],
    reminderMonths: [6, 9, 12],
};
const JOB_TITLE_DEFAULTS_OVERRIDES = {
    "Jardinier à domicile": { duplicationWeeks: [3] },
};
export function getJobTitleDefaults(jobTitle) {
    const overrides = jobTitle ? JOB_TITLE_DEFAULTS_OVERRIDES[jobTitle] : undefined;
    return { ...DEFAULT_JOB_TITLE_DEFAULTS, ...overrides };
}
//# sourceMappingURL=job-category-features.js.map